import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const ScreenshareIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <g clipPath="url(#clip0_1407_903)">
      <g clipPath="url(#clip1_1407_903)">
        <path
          d="M14 0C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H8.75V7.81055L10.8311 9.8916C11.124 10.1844 11.5987 10.1845 11.8916 9.8916C12.1845 9.59873 12.1844 9.12395 11.8916 8.83105L8.53027 5.46973C8.38968 5.32924 8.19876 5.25005 8 5.25C7.80116 5.25005 7.61033 5.32913 7.46973 5.46973L4.1084 8.83105C3.81586 9.12391 3.8158 9.59879 4.1084 9.8916C4.40121 10.1842 4.87609 10.1841 5.16895 9.8916L7.25 7.81055V16H2C0.895431 16 0 15.1046 0 14V2C0 0.895431 0.895431 0 2 0H14Z"
          fill="currentColor"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_1407_903">
        <rect fill="white" height="16" width="16" />
      </clipPath>
      <clipPath id="clip1_1407_903">
        <rect fill="white" height="16" width="16" />
      </clipPath>
    </defs>
  </svg>
);
